import { IcoInfoCircle } from "assets/icons";
import colors from "colors";

export default function AlertCard({
	children
}: {
	children: JSX.Element[] | JSX.Element | string;
}) {
	return (
		<div className="flex gap-4 bg-feedback-alert-high-50 px-4 py-5 rounded-lg">
			<div>
				<IcoInfoCircle size="40" color={colors["feedback-alert"]["pure-500"]} />
			</div>
			<div>{children}</div>
		</div>
	);
}
